import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Employee } from '../models/employee';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FilterEmployee } from '../models/filters/filter-employee';

@Injectable({
  providedIn: 'root'
})
export class EmployeeListService {

  constructor(private http: HttpClient) { }

  private employees: Employee[] = [];
    private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/employee';

  findAllPageableEmployee(filterEmployee: FilterEmployee, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterEmployee);
  }

  findEmployeeById(id: number): Observable<Employee> {
    return this.http.get<Employee>(`${this.url}/${id}`);
  }

  findEmployeeByNumber(employeeNumber: string): Observable<Employee> {
    return this.http.get<Employee>(`${this.url}/number/${employeeNumber}`);
  }
  
}
